"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IndexedTracker = void 0;
var IndexedTracker = /** @class */function () {
  function IndexedTracker() {}
  return IndexedTracker;
}();
exports.IndexedTracker = IndexedTracker;